import React from 'react';
import {
  Typography,
  Box,
  makeStyles,
  createStyles,
} from '@material-ui/core';

const useStyles = makeStyles(() => createStyles({
  coverroot: {
    backgroundColor: 'lightGray',
    color: 'black',
    height: '1122px',
    width: '793px',
  },
  topquote: {
    textAlign: 'left',
  },
  bottomquote: {
    textAlign: 'right',
  },
  spacer1: {
    height: '150px',
    width: '500px',
  },
  spacer2: {
    height: '200px',
    width: '500px',
  },
  text: {
    width: '600px',
    marginLeft: '100px',
  },
}));

const AboutUsPage = () => {
  const classes = useStyles();
  const QuotesIns = {
    ceo: 'Freddy Medina, CEO',
    ceoquote: 'Nuestro propósito es satisfacer la necesidad de laccomunidad boricua, y nuestra meta es facilitar la distribución de productos auténticos al por mayor en North Carolina.',
    cto: 'Antonio Rodriguez, CTO',
    ctoquote: 'En inruta, estamos comprometidos en un nuevo tipo de distribución donde nuestros clientes tienen fácil acceso a educación, herramientas y comunidad para que ellos a su vez puedan ofrecer un servicio al cliente ejemplar.',
  };
  return (
    <Box className={classes.coverroot}>
      <Box className={classes.spacer1} />
      <Box className={classes.topquote}>
        <Typography variant="h5" className={classes.text}>
          {`"${QuotesIns.ceoquote}"`}
        </Typography>
        <Typography variant="h6" className={classes.text}>
          {QuotesIns.ceo}
        </Typography>
      </Box>
      <Box className={classes.spacer2} />
      <Box className={classes.bottomquote}>
        <Typography variant="h5" className={classes.text}>
          {`"${QuotesIns.ctoquote}"`}
        </Typography>
        <Typography variant="h6" className={classes.text}>
          {QuotesIns.cto}
        </Typography>
      </Box>
    </Box>
  );
};

export default AboutUsPage;
